<template>
    <div class="bax-drug-patient-list">
        <div class="bax-drug-patient-summary d-md-flex align-items-center" v-if="!isTPN()">
            <div v-if="patient.details && patient.details.fullName && (patient.details.fullName.length + generalPatientID.length !== 0)" class="bax-patient-name">
                Patient Name
              <h3>{{ patient.details.fullName && patient.details.fullName.trim() ? patient.details.fullName : '--' }}</h3>
            </div>
            <div v-else class="bax-patient-name">
                <h3>No patient name</h3>
            </div>
            <div class="bax-patient-summary ml-auto mt-3 mt-md-0">
                <ul class="text-md-right">
                    <li v-if="generalPatientID.length">
                        Patient ID (MRN): <strong>{{ generalPatientID }}</strong>
                    </li>
                    <li>
                        Date of Birth : <strong>{{ patient.details.birthDateFormatted?patient.details.birthDateFormatted:'--' }}</strong>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bax-patient-drug-list" v-if="open">
            <ul>
                <drug-list
                    v-for="(drug, i) in patient.items"
                    :key="i"
                    :ref="'drugdetails' + i"
                    :drug="drug"
                    v-on:edit-drug="onEditDrug"
                    v-on:cancel-drug="$emit('cancel-drug', drug);"
                    v-on:order-changed="$emit('order-changed');"
                    v-on:item-open="$emit('item-open');"
                    v-on:item-close="$emit('item-close');"
                ></drug-list>
            </ul>
        </div>
    </div>
</template>

<script>
import tpnMixin from '@/mixins/tpnMixin';
import DrugList from './DrugList.vue';

export default {
    name: 'PatientList',
    mixins: [tpnMixin],
    components: {
        DrugList,
    },
    props: ['patient'],
    data() {
        return {
            open: true,
        };
    },
    computed: {
        generalPatientID() {
            if (typeof this.patient.details.medicalReferenceNumber !== 'undefined' && this.patient.details.medicalReferenceNumber !== '') {
                if (this.patient.details.medicalReferenceNumber.search(/\*\d+\*/) === -1) {
                    return this.patient.details.medicalReferenceNumber;
                }

                return '';
            }

            return '';
        },
    },
    created() {
    },
    mounted() {

    },
    methods: {
        // open edit drug modal
        onEditDrug(drug) {
          this.$emit('edit-drug', drug, this.patient);
        },
        toggle() {
            if (this.open) {
                this.open = false;
            } else {
                this.open = true;
            }
        },
        openAll() {
            this.patient.items.forEach((value, index) => {
                const childName = 'drugdetails' + index;
                this.$refs[childName][0].openDetails();
            });
        },
        closeAll() {
            this.patient.items.forEach((value, index) => {
                const childName = 'drugdetails' + index;
                this.$refs[childName][0].closeDetails();
            });
        },
    },
};
</script>
